module.exports = __webpack_public_path__ + "static/img/newbng.fdab1ae9.png";